import React from 'react';
import { Tr, Td, Checkbox, Text, Flex, Badge, Menu, MenuButton, IconButton, Portal, MenuList, MenuItem } from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import { FaRegEye } from 'react-icons/fa6';
import { TbListDetails } from 'react-icons/tb';
import { FiEdit3 } from 'react-icons/fi';
import { RiFileTransferLine, RiDeleteBinLine } from "react-icons/ri";

const ConfirmationOrderRow = React.memo(({
    val,
    isSelected,
    handleCheckboxClick,
    saveScrollPosition,
    tableRefCurrent,
    navigate,
    textSM,
    currentBusiness,
    t,
    onOpenModalEditStatus,
    toast,
    onOpenPreview,
    setQuickEditOrderId,
    onOpenQuickEdit,
    onOpenAlert,
    onOpenAssign
}) => {
    return (
        <Tr
            cursor="pointer"
            _hover={{ bg: "whiteAlpha.100" }}
            onClick={() => {
                saveScrollPosition(tableRefCurrent);
                navigate('/Detail-Gestion-confirmation', {
                    state: {
                        id: val.id,
                        tel: val.tel
                    }
                });
            }}
        >
            <Td position="sticky" left={0} zIndex={1} bg="white" _dark={{ bg: "gray.700" }} onClick={(e) => e.stopPropagation()}>
                <Checkbox size="md" colorScheme='purple' _focus={"none"} _active={'none'}
                    onChange={() => handleCheckboxClick(val.id)}
                    isChecked={isSelected} />
            </Td>
            <Td>
                <Text>{val.code}</Text>
            </Td>
            <Td>
                {val.assigned_to ?
                    <Flex flexDirection="column">
                        <Text>{val.first_name}</Text>
                        <Text>{val.last_name}</Text>
                    </Flex>
                    :
                    <Text>-</Text>
                }
            </Td>
            <Td>
                <Flex flexDirection={"column"}>
                    <Text fontWeight='semibold'>{val.full_name}</Text>
                    {val.email !== "undefined" && <Text fontSize='sm' color={textSM}>{val.email}</Text>}
                </Flex>
            </Td>
            <Td>
                <Flex flexDirection={"column"}>
                    <Text fontSize={'md'}>{val.pays}, {val.ville}</Text>
                    <Text fontSize={'sm'} color={textSM}>{val.address}</Text>
                </Flex>
            </Td>
            <Td>
                <a href={`https://wa.me/${val.tel}`} target='blank' onClick={(e) => e.stopPropagation()}>
                    {val.tel}
                </a>
            </Td>
            <Td>
                <Text>{val.sourceAPI}</Text>
            </Td>
            <Td>
                <Badge colorScheme={
                    val.status_confirmation !== 'Confirmé'
                        ? (['Mauvais numéro', 'Annulé'].includes(val.status_confirmation))
                            ? 'red'
                            : (val.status_confirmation === 'Nouveau')
                                ? 'blue'
                                : 'orange'
                        : 'green'
                }
                    rounded="xl"
                    px={2}
                    cursor='pointer'
                    onClick={(e) => {
                        e.stopPropagation();
                        if (val?.status_stock === null || val?.status_stock === '') {
                            onOpenModalEditStatus(val.id)
                        } else {
                            toast({
                                description:
                                    <Flex flexDirection='column'>
                                        <Text fontWeight='semibold'>{t('Désolé!')}</Text>
                                        {val?.status_stock !== 'Collecté'
                                            ?
                                            <Text>{t('Impossible de modifier le statut de cette commande car elle est déjà en stock.')}</Text>
                                            :
                                            <Text>{t('Impossible de modifier le statut de cette commande car elle est déjà en Livraison.')}</Text>
                                        }
                                    </Flex>
                                ,
                                status: 'error',
                                duration: 5000,
                                isClosable: true,
                                variant: 'left-accent',
                                position: 'top-center'
                            })
                        }
                    }}>
                    {t(`${val.status_confirmation}`)}
                </Badge>
            </Td>
            <Td>
                <Text textAlign='center'>
                    {val.coupon ? val.couponTitle : '-'}
                </Text>
            </Td>
            <Td>
                <Flex gap={1} alignItems="center">
                    <Text color={val?.coupon && 'gray.400'} fontSize={val?.coupon && 15} fontWeight='semibold' textDecoration={val?.coupon && 'line-through'}>{val?.price}</Text>
                    <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                </Flex>
                {
                    val?.coupon &&
                    <Flex gap={1} alignItems="center">
                        <Text fontWeight='semibold'>{val?.priceWithCoupon}</Text>
                        <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                    </Flex>
                }
            </Td>
            <Td>
                <Flex flexDirection="column">
                    <Text fontSize="sm" fontWeight="medium">{new Date(val.date_creation).toLocaleDateString()}</Text>
                    <Text fontSize="xs" color="gray.500">{new Date(val.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                </Flex>
            </Td>
            <Td>
                {val.date_modification ? (
                    <Flex flexDirection="column">
                        <Text fontSize="sm" fontWeight="medium">{new Date(val.date_modification).toLocaleDateString()}</Text>
                        <Text fontSize="xs" color="gray.500">{new Date(val.date_modification).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                    </Flex>
                ) : (
                    <Text fontSize="sm" color="gray.400">-</Text>
                )}
            </Td>
            <Td position="sticky" right={0} zIndex={1} bg="white" _dark={{ bg: "gray.700" }} onClick={(e) => e.stopPropagation()}>
                <Menu>
                    <MenuButton
                        as={IconButton}
                        aria-label='Options'
                        icon={<HamburgerIcon />}
                        variant='outline'
                    />
                    <Portal>
                        <MenuList zIndex={9999}>
                            <MenuItem icon={<FaRegEye size={18} />} onClick={() => {
                                onOpenPreview(val.id)
                            }}>
                                {t("Aperçu")}
                            </MenuItem>
                            <MenuItem icon={<TbListDetails size={18} />} onClick={() => {
                                saveScrollPosition(tableRefCurrent);
                                navigate('/Detail-Gestion-confirmation', {
                                    state: {
                                        id: val.id,
                                        tel: val.tel
                                    }
                                });
                            }}>
                                {t("Détails")}
                            </MenuItem>
                            {val.status_confirmation !== 'Confirmé' && !val.status_stock && !val.status_delivery && !val.status_facture && (
                                <MenuItem icon={<FiEdit3 size={18} />} onClick={() => {
                                    setQuickEditOrderId(val.id);
                                    onOpenQuickEdit();
                                }}>
                                    {t("Quick Edit")}
                                </MenuItem>
                            )}
                            <MenuItem icon={<RiFileTransferLine size={18} />} onClick={() => {
                                handleCheckboxClick(val.id)
                                onOpenAssign()
                            }}>
                                {t("Attribuer")}
                            </MenuItem>
                            <MenuItem icon={<RiDeleteBinLine size={18} />} onClick={() => {
                                onOpenAlert(val.id, val.date_creation)
                            }}>
                                {t("Supprimer")}
                            </MenuItem>
                        </MenuList>
                    </Portal>
                </Menu>
            </Td>
        </Tr>
    )
}, (prevProps, nextProps) => {
    return prevProps.val === nextProps.val && prevProps.isSelected === nextProps.isSelected;
});

export default ConfirmationOrderRow;
